// https://github.com/formatjs/formatjs/blob/main/packages/react-intl/examples/StaticTypeSafetyAndCodeSplitting/intlHelpers.tsx
import type { PrimitiveType } from "intl-messageformat";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { FormatNumberOptions, useIntl } from "react-intl";
// "import type" ensures en messages aren't bundled by default
import enMessages, * as sourceOfTruth from "../translations/en.json";

const DEFAULT_LOCALE = "en";

export type LocaleMessages = typeof sourceOfTruth;
export type LocaleKey = keyof LocaleMessages;

export function useFormatMessage(): (
  id: LocaleKey, // only accepts valid keys, not any string
  values?: Record<string, PrimitiveType>
) => string {
  const intl = useIntl();
  return (id, values) => intl.formatMessage({ id }, values);
}

export function useFormatNumber(): (
  num: number,
  options?: FormatNumberOptions
) => string {
  const intl = useIntl();
  return (
    num,
    options = {
      style: "decimal",
      maximumFractionDigits: 2,
    }
  ) => intl.formatNumber(num, options);
}

export const loadIntlMessages = () => {
  let locale = DEFAULT_LOCALE;

  if (typeof window !== "undefined") {
    // if available use browser preferred language
    locale = window.navigator.language.toLowerCase();
  }

  let translatedMessages: Record<string, string>;
  switch (locale) {
    default:
      translatedMessages = enMessages;
  }
  return { locale, messages: translatedMessages };
};
